(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Countdown ---------- */
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function format(el, remaining) {
      var days = Math.floor(remaining / 86400);
      var hours = Math.floor((remaining % 86400) / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;

      if (el.getAttribute('data-format') === 'compact') {
        return (
          pad(days) + el.getAttribute('data-short-days') + ' ' +
          pad(hours) + el.getAttribute('data-short-hours') + ' ' +
          pad(minutes) + el.getAttribute('data-short-minutes') + ' ' +
          pad(seconds) + el.getAttribute('data-short-seconds')
        );
      }
      return [
        days + ' ' + el.getAttribute('data-unit-days'),
        hours + ' ' + el.getAttribute('data-unit-hours'),
        minutes + ' ' + el.getAttribute('data-unit-minutes'),
        seconds + ' ' + el.getAttribute('data-unit-seconds')
      ].join(', ');
    }

    function tick(el) {
      var end = parseInt(el.getAttribute('data-end'), 10);
      if (!end || end <= 0) return true;
      var output = el.querySelector('[data-countdown-output]');
      var remaining = end - Math.floor(Date.now() / 1000);
      if (remaining <= 0) {
        if (el.getAttribute('data-hide-expired') === 'true') {
          el.setAttribute('hidden', '');
          // Marks the item so the rotator stops offering it a turn.
          el.setAttribute('data-expired', 'true');
        } else if (output) {
          output.textContent = el.getAttribute('data-expired-text') || '';
        }
        return true;
      }
      el.removeAttribute('hidden');
      el.removeAttribute('data-expired');
      if (output) output.textContent = format(el, remaining);
      return false;
    }

    function startCountdown(el) {
      if (el.dataset.countdownRunning) return;
      if (tick(el)) return;
      el.dataset.countdownRunning = '1';
      var timer = setInterval(function () {
        if (tick(el)) {
          clearInterval(timer);
          delete el.dataset.countdownRunning;
        }
      }, 1000);
    }

    /* ---------- Rotation ---------- */
    function startRotator(bar) {
      if (bar.dataset.rotatorReady) return;
      bar.dataset.rotatorReady = '1';

      var interval = parseInt(bar.getAttribute('data-interval'), 10);
      if (isNaN(interval) || interval < 1500) interval = 5000;

      var progress = bar.querySelector('[data-ann-progress]');
      var timer = null;
      var paused = false;
      var current = 0;

      function eligible() {
        // Re-read each cycle: an expiring countdown can drop out mid-session.
        return Array.prototype.filter.call(
          bar.querySelectorAll('[data-ann-item]'),
          function (el) {
            return el.getAttribute('data-expired') !== 'true';
          }
        );
      }

      function paint(list, i) {
        list.forEach(function (el, n) {
          el.classList.toggle('is-active', n === i);
        });
        if (!progress) return;
        // Restarting a CSS animation needs a reflow between class removals.
        progress.classList.remove('is-running');
        void progress.offsetWidth;
        if (!paused) progress.classList.add('is-running');
      }

      function step() {
        var list = eligible();
        if (list.length < 2) {
          paint(list, 0);
          return;
        }
        current = (current + 1) % list.length;
        paint(list, current);
      }

      function run() {
        stop();
        var list = eligible();
        if (list.length < 2) return;
        timer = setInterval(step, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      var list = eligible();
      paint(list, 0);
      if (list.length < 2) return;
      run();

      // Pausing on hover/focus gives the visitor a way to finish reading, and
      // keeps a tabbed link from sliding away mid-tab.
      function pause() {
        paused = true;
        stop();
        if (progress) progress.classList.remove('is-running');
      }
      function resume() {
        if (!paused) return;
        paused = false;
        paint(eligible(), current);
        run();
      }
      bar.addEventListener('mouseenter', pause);
      bar.addEventListener('mouseleave', resume);
      bar.addEventListener('focusin', pause);
      bar.addEventListener('focusout', resume);
    }

    function init() {
      var cds = document.querySelectorAll('[data-countdown]');
      for (var i = 0; i < cds.length; i++) startCountdown(cds[i]);

      // Reduced motion collapses rotate/ticker to the static line in CSS, so the
      // rotator must not run — it would hide all but one message.
      if (reduced) return;
      var bars = document.querySelectorAll('[data-announcement-bar][data-mode="rotate"]');
      for (var j = 0; j < bars.length; j++) startRotator(bars[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    // Bind once at the document level. Handlers re-query the drawer at call
    // time, so add-to-cart interception works even if the drawer markup loads
    // after this script — and we NEVER navigate away on add to cart.
    if (window.__lisseCartBound) return;
    window.__lisseCartBound = true;

    var SECTION_ID = 'cart-drawer';

    function root() { return document.querySelector('[data-cart-drawer]'); }
    function attr(name, fallback) {
      var r = root();
      return (r && r.getAttribute(name)) || fallback;
    }

    function open() {
      var r = root();
      if (!r) return;
      r.classList.add('is-open');
      r.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      var closeBtn = r.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      var r = root();
      if (!r) return;
      r.classList.remove('is-open');
      r.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    function setCount(n) {
      var badges = document.querySelectorAll('[data-cart-count-badge]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = n;
        if (n > 0) {
          badges[i].removeAttribute('hidden');
        } else {
          badges[i].setAttribute('hidden', '');
        }
      }
    }

    // Swap the drawer contents from a rendered section HTML string.
    function render(html) {
      var r = root();
      if (!r || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-contents]');
      var current = r.querySelector('[data-cart-drawer-contents]');
      if (fresh && current) {
        current.replaceWith(fresh);
        setCount(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
      }
    }

    // Fetch the section fresh (used when a mutation response lacks sections).
    function refresh() {
      var rootUrl = attr('data-root-url', '/');
      var url = rootUrl + (rootUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SECTION_ID;
      return fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(render)
        .catch(function () {});
    }

    function busy(on) {
      var r = root();
      var panel = r && r.querySelector('.cart-drawer__panel');
      if (panel) panel.classList.toggle('is-loading', !!on);
    }

    function showError(msg) {
      var r = root();
      var el = r && r.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = msg || 'Algo correu mal. Tenta novamente.';
      el.removeAttribute('hidden');
    }

    function clearError() {
      var r = root();
      var el = r && r.querySelector('[data-cart-error]');
      if (el) {
        el.textContent = '';
        el.setAttribute('hidden', '');
      }
    }

    function applyResponse(json) {
      if (json && json.sections && json.sections[SECTION_ID]) {
        render(json.sections[SECTION_ID]);
        return Promise.resolve();
      }
      return refresh();
    }

    function addToCart(form) {
      var addUrl = attr('data-cart-add-url', '/cart/add');
      var rootUrl = attr('data-root-url', '/');
      var data = new FormData(form);
      data.append('sections', SECTION_ID);
      data.append('sections_url', rootUrl);
      busy(true);
      clearError();
      open(); // optimistic: show the fold immediately
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (res) {
          return res.json().then(function (body) { return { ok: res.ok, body: body }; });
        })
        .then(function (res) {
          if (!res.ok) {
            // Surface Shopify's reason (e.g. sold out, unavailable) instead of a silent empty fold.
            var msg = (res.body && (res.body.description || res.body.message)) || 'We could not add this item to your cart.';
            if (window.console) console.error('[cart] add failed:', res.body);
            showError(msg);
            return refresh();
          }
          return applyResponse(res.body);
        })
        .then(function () { busy(false); })
        .catch(function (err) {
          busy(false);
          if (window.console) console.error('[cart] add error:', err);
          showError('Connection error — please try again.');
          refresh();
        });
    }

    function changeQty(key, qty) {
      var changeUrl = attr('data-cart-change-url', '/cart/change');
      var rootUrl = attr('data-root-url', '/');
      busy(true);
      fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: SECTION_ID, sections_url: rootUrl })
      })
        .then(function (res) { return res.json(); })
        .then(applyResponse)
        .then(function () { busy(false); })
        .catch(function () { busy(false); refresh(); });
    }

    // Clicks: cart toggle, close/backdrop, and quantity controls (delegated).
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); open(); return; }

      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) {
        e.preventDefault();
        close();
        return;
      }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute('data-line-key');
        var to = parseInt(qtyBtn.getAttribute('data-qty-to'), 10);
        if (key && !isNaN(to)) changeQty(key, to);
      }
    });

    // Intercept every add-to-cart submission (capture phase, early) so the
    // customer is never navigated to /cart/add.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || typeof form.getAttribute !== 'function') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      addToCart(form);
    }, true);

    document.addEventListener('keydown', function (e) {
      var r = root();
      if (e.key === 'Escape' && r && r.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Ownership of the newsletter confirmation.
    //
    // Shopify's form.posted_successfully? is true for EVERY customer form on the
    // page once any one of them has posted, and this theme has up to three
    // (footer, email popup, quiz). So the footer used to congratulate people who
    // had actually subscribed through the popup. The flag below is set only when
    // this form is submitted, and is the only thing that reveals its success line.
    // (No Liquid tags in here — Liquid is not rendered inside a javascript block
    // and writing one causes a parse error.)
    var FLAG = 'um_footer_pending';

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== 'footer-newsletter') return;
      try { sessionStorage.setItem(FLAG, '1'); } catch (err) {}
    });

    function reveal() {
      var ok = document.querySelector('[data-footer-ok]');
      if (!ok) return; // this page load wasn't a customer-form success at all
      var pending = false;
      try { pending = sessionStorage.getItem(FLAG) === '1'; } catch (err) {}
      if (!pending) return; // someone else's submission — leave the form as it is
      try { sessionStorage.removeItem(FLAG); } catch (err) {}
      ok.hidden = false;
      var fields = document.querySelector('[data-footer-fields]');
      if (fields) fields.hidden = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__lisseHeaderBound) return;
    window.__lisseHeaderBound = true;

    var header = document.querySelector('.header-section');
    var announcement = document.querySelector('.announcement-bar-section');

    // Search panel conveniences. The <details> element already opens, closes
    // and handles the keyboard on its own; these are only the parts it cannot
    // do — put the caret in the field, and get out of the way on Escape or a
    // click elsewhere. Without JS the panel still opens and still submits.
    (function search() {
      var box = document.querySelector('[data-site-search]');
      if (!box) return;
      var field = box.querySelector('.site-search__input');

      box.addEventListener('toggle', function () {
        if (box.open && field) field.focus();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && box.open) {
          box.open = false;
          var summary = box.querySelector('summary');
          if (summary) summary.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (box.open && !box.contains(e.target)) box.open = false;
      });
    })();

    // Position the sticky header directly beneath the (also sticky) announcement bar.
    function setOffset() {
      if (!header) return;
      var h = announcement ? Math.round(announcement.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--header-top', h + 'px');
      // Bottom edge of the sticky header stack (announcement + header). The product
      // gallery pins flush beneath this so no copy ever shows above the photo.
      var headerH = Math.round(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--header-bottom', (h + headerH) + 'px');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        document.body.classList.toggle('is-scrolled', window.scrollY > 16);
        setOffset();
        ticking = false;
      });
    }

    setOffset();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setOffset);
    // Re-measure after images/fonts settle, or the header height (and therefore the
    // gallery's sticky offset) can be measured too early and end up stale.
    window.addEventListener('load', setOffset);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setOffset); }
    // The bar's height changes as it shrinks on mobile — re-measure when it settles.
    if (announcement) announcement.addEventListener('transitionend', setOffset);
    document.addEventListener('shopify:section:load', setOffset);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-ba-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba-frame]').forEach(function (frame) {
      var range = frame.querySelector('[data-ba-range]');
      if (!range) return;
      range.addEventListener('input', function () {
        frame.style.setProperty('--pos', range.value + '%');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba-filter]').forEach(function (bar) {
      var scope = bar.closest('section') || document;
      var grid = scope.querySelector('[data-ba-grid]');
      if (!grid) return;
      var tabs = bar.querySelectorAll('[data-ba-cat]');
      var cards = grid.querySelectorAll('[data-ba-card]');
      // Group headings only make sense when everything is shown at once.
      var groups = grid.querySelectorAll('.lisse-ba__group');

      function apply(cat) {
        cards.forEach(function (c) {
          c.hidden = !(cat === 'all' || c.getAttribute('data-ba-cat') === cat);
        });
        groups.forEach(function (g) { g.hidden = cat !== 'all'; });
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ba-cat') === cat;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { apply(t.getAttribute('data-ba-cat')); });
      });

      var start = bar.querySelector('.is-active');
      if (start) apply(start.getAttribute('data-ba-cat'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bundle]:not([data-bundle-ready])').forEach(function (root) {
      root.setAttribute('data-bundle-ready', 'true');
      var tiers = root.querySelectorAll('[data-tier]');
      var input = root.querySelector('[data-bundle-input]');
      var gifts = root.querySelectorAll('[data-gift-tier]');

      function apply(btn) {
        tiers.forEach(function (t) {
          var on = t === btn;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (input && btn.dataset.variant) input.value = btn.dataset.variant;
        // Gifts unlock at a tier index; dim the ones this tier does not reach.
        var reach = parseInt(btn.dataset.unlock || '0', 10);
        gifts.forEach(function (g) {
          var need = parseInt(g.dataset.giftTier || '1', 10);
          g.classList.toggle('is-locked', need > reach);
        });
      }

      tiers.forEach(function (t) { t.addEventListener('click', function () { apply(t); }); });
      var initial = root.querySelector('[data-tier].is-selected') || tiers[0];
      if (initial) apply(initial);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-lisse-cdbar]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    bars.forEach(function (bar) {
      var end = parseInt(bar.getAttribute('data-end'), 10);
      if (!end) return;
      var d = bar.querySelector('[data-cd-d]');
      var h = bar.querySelector('[data-cd-h]');
      var m = bar.querySelector('[data-cd-m]');
      var s = bar.querySelector('[data-cd-s]');
      function tick() {
        var r = end - Math.floor(Date.now() / 1000);
        if (r <= 0) { bar.style.display = 'none'; return true; }
        d.textContent = pad(Math.floor(r / 86400));
        h.textContent = pad(Math.floor((r % 86400) / 3600));
        m.textContent = pad(Math.floor((r % 3600) / 60));
        s.textContent = pad(r % 60);
        return false;
      }
      if (tick()) return;
      var t = setInterval(function () { if (tick()) clearInterval(t); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const accs = document.querySelectorAll('[data-accordion]:not([data-accordion-ready])');
    accs.forEach(function (acc) {
      acc.setAttribute('data-accordion-ready', 'true');
      acc.querySelectorAll('.lisse-accordion__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const item = btn.parentElement;
          const wasOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !wasOpen);
          btn.setAttribute('aria-expanded', String(!wasOpen));
          const plus = btn.querySelector('.lisse-accordion__plus');
          if (plus) plus.textContent = wasOpen ? '+' : '–';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-lisse-hero]:not([data-hero-ready])');
    roots.forEach(function (root) {
      root.setAttribute('data-hero-ready', 'true');

      const slides = root.querySelectorAll('[data-slide]');
      const thumbs = root.querySelectorAll('[data-thumb]');

      function show(i) {
        if (i < 0 || i >= slides.length) return;
        const key = String(i);
        slides.forEach(function (s) {
          const on = s.dataset.slide === key;
          s.classList.toggle('is-active', on);
          // Um video num slide escondido nao arranca sozinho (display:none).
          // Toca quando o slide passa a ativo, pausa e rebobina quando sai.
          const v = s.querySelector('video');
          if (v) {
            if (on) { const pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else { v.pause(); v.currentTime = 0; }
          }
        });
        thumbs.forEach(function (t) {
          const on = t.dataset.thumb === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      function current() {
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return i;
        }
        return 0;
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { show(parseInt(thumb.dataset.thumb, 10)); });
      });

      /* Deslizar a galeria com o dedo. Os slides estão empilhados em absolute,
         por isso não há scroll nativo para aproveitar — mede-se o gesto e
         chama-se o mesmo show() dos thumbs, para os dois ficarem sempre em
         sincronia. Só conta como swipe se o movimento for claramente
         horizontal (>40px em X e maior que o Y), senão roubava o scroll
         vertical da página. */
      const stage = root.querySelector('.lisse-hero__stage');
      if (stage && slides.length > 1) {
        let x0 = null, y0 = null;
        stage.addEventListener('touchstart', function (e) {
          const t = e.changedTouches[0];
          x0 = t.clientX; y0 = t.clientY;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          const t = e.changedTouches[0];
          const dx = t.clientX - x0, dy = t.clientY - y0;
          x0 = null; y0 = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          const i = current();
          show(dx < 0 ? Math.min(i + 1, slides.length - 1) : Math.max(i - 1, 0));
        }, { passive: true });
      }

      const opts = root.querySelectorAll('[data-purchase-option]');
      const priceDisplay = root.querySelector('[data-price-display]');
      const priceNote = root.querySelector('[data-price-note]');
      const ctaTotal = root.querySelector('[data-cta-total]');
      const priceCompare = root.querySelector('[data-price-compare]');
      const variantInput = root.querySelector('[data-variant-input]');
      const planInput = root.querySelector('[data-selling-plan-input]');
      opts.forEach(function (opt) {
        const radio = opt.querySelector('input[type=radio]');
        if (!radio) return;
        radio.addEventListener('change', function () {
          opts.forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          if (priceDisplay && opt.dataset.price) priceDisplay.textContent = opt.dataset.price;
          if (priceNote) priceNote.textContent = opt.dataset.note || '';
          if (ctaTotal && opt.dataset.price) ctaTotal.textContent = opt.dataset.price;
          // Keep the actual add-to-cart payload in sync with the chosen option.
          if (variantInput && opt.dataset.variant) variantInput.value = opt.dataset.variant;
          if (planInput) planInput.value = opt.dataset.sellingPlan || '';
          document.dispatchEvent(new CustomEvent('lisse:price-change', {
            detail: {
              price: opt.dataset.price || '',
              note: opt.dataset.note || '',
              variant: opt.dataset.variant || '',
              sellingPlan: opt.dataset.sellingPlan || ''
            }
          }));
        });
      });

      // The variant/subscription buy box is now driven by the shared controller
      // in snippets/lisse-buybox-controls.liquid (single state across hero +
      // sticky bar). Only the legacy purchase-option path above runs here.
    });

    // Accordion binding (idempotent — shared with objections/faq sections)
    const accs = document.querySelectorAll('[data-accordion]:not([data-accordion-ready])');
    accs.forEach(function (acc) {
      acc.setAttribute('data-accordion-ready', 'true');
      acc.querySelectorAll('.lisse-accordion__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const item = btn.parentElement;
          const wasOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !wasOpen);
          btn.setAttribute('aria-expanded', String(!wasOpen));
          const plus = btn.querySelector('.lisse-accordion__plus');
          if (plus) plus.textContent = wasOpen ? '+' : '–';
        });
      });
    });
  })();

  // ---- Bundle ladder -> the hero's own buy form -------------------------
  // Selecting a tier rewrites [data-variant-input] and the CTA total, so the
  // single Add to Cart posts the chosen bundle. Gifts above the chosen rung
  // dim rather than disappear.
  (function () {
    document.querySelectorAll('[data-ladder]:not([data-ladder-ready])').forEach(function (root) {
      root.setAttribute('data-ladder-ready', 'true');
      var box = root.closest('[data-buybox]') || document;
      var tiers = root.querySelectorAll('[data-tier]');
      var gifts = root.querySelectorAll('[data-gift-tier]');
      var input = box.querySelector('[data-variant-input]');
      var total = box.querySelector('[data-buy-cta-total]');
      var save = box.querySelector('[data-buy-cta-save]');

      function apply(btn) {
        tiers.forEach(function (t) {
          var on = t === btn;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (input && btn.dataset.variant) input.value = btn.dataset.variant;
        if (total && btn.dataset.total) total.textContent = btn.dataset.total;
        // The saving shown on the button belongs to the single unit; on a
        // multi-unit tier it would understate the discount, so it is hidden
        // rather than left to say something untrue.
        if (save) save.hidden = (parseInt(btn.dataset.unlock, 10) || 1) > 1;
        var unlock = parseInt(btn.dataset.unlock, 10) || 1;
        gifts.forEach(function (g) {
          var need = parseInt(g.getAttribute('data-gift-tier'), 10) || 1;
          g.classList.toggle('is-locked', need > unlock);
        });
      }

      tiers.forEach(function (t) {
        t.addEventListener('click', function () { apply(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); apply(t); }
        });
      });

      var current = root.querySelector('[data-tier].is-selected') || tiers[0];
      if (current) apply(current);

      tiers.forEach(function (t) {
        t.addEventListener('click', function () { current = t; });
      });

      // Another script on the page writes the default variant into the form on
      // load, which would silently post one device while the ladder showed the
      // 3-pack ringed. Re-assert after load, and again at submit — the only
      // moment that actually decides what the customer is charged.
      window.addEventListener('load', function () { if (current) apply(current); });
      var form = box.querySelector('form[action*="/cart/add"]');
      if (form) form.addEventListener('submit', function () { if (current) apply(current); });
    });
  })();

  // ---- Booking-style scarcity -------------------------------------------
  (function () {
    document.querySelectorAll('[data-scarcity]:not([data-scarcity-ready])').forEach(function (root) {
      root.setAttribute('data-scarcity-ready', 'true');
      var d = root.dataset;
      var start = parseInt(d.unitsStart, 10) || 14;
      var floorN = parseInt(d.unitsFloor, 10) || 3;
      var days = Math.max(2, parseInt(d.unitsDays, 10) || 21);
      var vMin = parseInt(d.viewMin, 10) || 4;
      var vMax = parseInt(d.viewMax, 10) || 13;
      var uEl = root.querySelector('[data-scarcity-units]');
      var vEl = root.querySelector('[data-scarcity-viewers]');
      var uTpl = uEl.getAttribute('data-tpl') || '';
      var vTpl = vEl.getAttribute('data-tpl') || '';

      // Units are a pure function of the day, so every visitor sees the same
      // number on the same date and it does not jump between page loads.
      // Anchored to a real date so the merchant decides which day a batch
      // starts full, instead of the cycle landing wherever the epoch puts it.
      var anchorDay = 0;
      var parsed = Date.parse(d.unitsAnchor || '');
      if (!isNaN(parsed)) anchorDay = Math.floor(parsed / 86400000);
      function unitsToday() {
        var day = Math.floor(Date.now() / 86400000);
        var pos = (((day - anchorDay) % days) + days) % days;
        var span = start - floorN;
        return start - Math.round(span * (pos / (days - 1)));
      }

      var units = unitsToday();
      if (uTpl) uEl.textContent = uTpl.replace('{units}', units);

      // Viewers sit just under the units left, then drift by one every 20-40s.
      // Drifting rather than re-rolling is what makes it read as a live count
      // instead of a random number that changes when you blink.
      // Anchored to a share of the units left, then allowed to wander a few
      // either side of that anchor rather than random-walking to an edge and
      // sticking there. Tie them together and the pair stays coherent whatever
      // batch size is configured.
      var ratio = (parseFloat(d.viewRatio) || 45) / 100;
      var anchor = Math.round(units * ratio);
      if (anchor < vMin) anchor = vMin;
      if (anchor > vMax) anchor = vMax;
      var lo = Math.max(vMin, anchor - 4);
      var hi = Math.min(vMax, anchor + 4);
      var v = anchor;
      function paint() { if (vTpl) vEl.textContent = vTpl.replace('{n}', v); }
      paint();
      // Every 3-7s: often enough to read as live, and a single text-node swap
      // costs nothing measurable. Browsers throttle this to once a minute once
      // the tab is backgrounded, which is exactly what we want.
      (function tick() {
        setTimeout(function () {
          v += Math.random() < 0.5 ? -1 : 1;
          if (v < lo) v = lo + 1;
          if (v > hi) v = hi - 1;
          paint();
          tick();
        }, 3000 + Math.random() * 4000);
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-proof"] && !Shopify.designMode) return;
  try {
    
  // O tema respeita prefers-reduced-motion nas restantes animacoes; um loop
  // em autoplay tem de o respeitar tambem. CSS nao pausa video.
  (function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    function apply() {
      document.querySelectorAll('.lisse-proof__video').forEach(function (v) {
        if (mq.matches) { v.pause(); v.removeAttribute('autoplay'); }
        else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    if (document.readyState !== 'loading') apply();
    else document.addEventListener('DOMContentLoaded', apply);
    mq.addEventListener && mq.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('[data-sticky-bar]:not([data-sticky-ready])');
    bars.forEach(function (bar) {
      bar.setAttribute('data-sticky-ready', 'true');

      // Appear once the main buy box scrolls out of view, hide when it's back.
      // Pixel-agnostic — watches the actual element via IntersectionObserver.
      const selector = bar.getAttribute('data-observe') || '[data-buybox]';
      const target = document.querySelector(selector);
      if (!target || !('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisse-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vids]:not([data-vids-ready])').forEach(function (track) {
      track.setAttribute('data-vids-ready', 'true');
      var vids = track.querySelectorAll('video');
      vids.forEach(function (v) {
        // One at a time: a second clip starting while the first plays turns the
        // row into noise and doubles the data cost on a phone.
        v.addEventListener('play', function () {
          vids.forEach(function (other) { if (other !== v) other.pause(); });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
